import { AdminDashboardPage } from "../AdminDashboardPage";
import {
  DASHBOARD_ASSETS,
  DASHBOARD_PROJECTS,
  DASHBOARD_SETTINGS,
  DASHBOARD_THREADS,
} from "../fixtures";
import { DashboardModalState } from "../components/modals/DashboardModalHost";
import { getDashboardVisualScenario } from "./manifest";
import { seedDashboardAssetRuntimeRecord } from "../services/dashboardAssetUploadService";

// Seed the pergola model so the 3D viewer renders in the asset modal
seedDashboardAssetRuntimeRecord({
  assetId: 'engine-main-v2',
  previewUrl: '/pergola-camera-export.glb',
  previewKind: 'model',
  companyId: 'weijia',
  productId: 'pergola-pro',
});

function getScenarioIdFromSearch(): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  return new URLSearchParams(window.location.search).get("scenario");
}

function getScenarioModalState(scenarioId: string | null): DashboardModalState {
  const scenario = getDashboardVisualScenario(scenarioId);
  const modal = scenario?.modal;
  if (!modal) {
    return { kind: "none" };
  }

  switch (modal.kind) {
    case "asset": {
      const asset = DASHBOARD_ASSETS.find(
        (entry) => entry.id === modal.assetId,
      );
      return asset ? { kind: "asset", asset } : { kind: "none" };
    }
    case "project": {
      const project = DASHBOARD_PROJECTS.find(
        (entry) => entry.id === modal.projectId,
      );
      return project
        ? { kind: "project", projectId: project.id, projectName: project.name }
        : { kind: "none" };
    }
    case "attachment": {
      const thread = DASHBOARD_THREADS.find(
        (entry) => entry.id === modal.threadId,
      );
      return thread ? { kind: "attachment", thread } : { kind: "none" };
    }
    case "security":
      return { kind: "security" };
    default:
      return { kind: "none" };
  }
}

export function DashboardVisualRegressionPage() {
  const scenarioId = getScenarioIdFromSearch();
  const scenario = getDashboardVisualScenario(scenarioId);

  if (!scenario) {
    return (
      <div className="auth-shell" data-oid="ge:jaif">
        <div className="auth-card" data-oid="vh-4bkx">
          <div className="auth-card__content" data-oid="uacm-d3">
            <div className="auth-badge" data-oid="lp6s7v3">
              Visual Regression
            </div>
            <h1 className="auth-title" data-oid="bkz_:a4">
              Unknown dashboard scenario.
            </h1>
            <p className="auth-subtitle" data-oid="_ng9pk1">
              Check the <code data-oid="2hyrdsg">scenario</code> query parameter
              against the shared dashboard visual regression manifest.
            </p>
          </div>
        </div>
      </div>
    );
  }

  const activeThread =
    DASHBOARD_THREADS.find((thread) => thread.id === scenario.threadId) ??
    DASHBOARD_THREADS[0];

  return (
    <div
      data-reference-image={scenario.referenceImage ?? ""}
      data-scenario={scenario.id}
      data-testid="dashboard-visual-regression-ready"
      data-oid="8ldg:bb"
    >
      <AdminDashboardPage
        canMutate
        displayName="Industrial Hub"
        initialAssetTab={scenario.assetTab}
        initialModal={getScenarioModalState(scenario.id)}
        initialSection={scenario.section}
        initialSettings={DASHBOARD_SETTINGS}
        initialThread={activeThread}
        onSignOut={async () => undefined}
        role="admin"
        signOutError={null}
        data-oid=":s9zrz-"
      />
    </div>
  );
}
